<template>
  <div class="personal-data-container">
    <div class="loading-style" v-loading="loading"></div>
    <div class="content">
      <div class="personal-header">
        <img class="icon1" src="@/assets/images/b2.png" />
        <img class="icon2" src="@/assets/images/b2_1.png" />
        <span>做任务-得福报</span>
      </div>
      <div class="subtitle">
        <p>福报可在慈脉铁粉之家小程序中提现到</p>
        <p>微信零钱、兑换产品和服务</p>
      </div>
      <div class="personal-content">
        <div
          class="fubao-item"
          v-for="(item, index) in integralTaskList"
          :key="item + index"
        >
          <div class="fubao-item-content">
            <div class="title">{{ item.taskName }}</div>
            <div class="tips">+ {{ item.integral }}福报</div>
          </div>
          <div class="improve-block">
            <el-button
              v-if="Number(item.receiveType) === 0"
              type="danger"
              size="small"
              @click="goCompleteHandle"
              >去完善</el-button
            >
            <el-button
              v-if="
                Number(item.receiveType) === 1 || Number(item.receiveType) === 3
              "
              type="danger"
              size="small"
              @click="takeHandle(item)"
              >领取</el-button
            >
            <div class="awm" v-if="Number(item.receiveType) === 2">
              <div class="pic">
                <img src="@/assets/images/awm.png" />
              </div>
              <div class="text">微信扫码使用福报</div>
            </div>
            <!-- <el-popover
              popper-class="popover-code"
              placement="bottom"
              width="200"
              trigger="manual"
              v-model="visible"
            >
              <img src="@/assets/images/awm.png" />
              <div class="text">微信扫一扫</div>
              <el-button slot="reference" @click="visible = !visible"
                >使用福报</el-button
              >
            </el-popover> -->
            <!-- <el-button
              v-if="Number(item.receiveType) === 2"
              style="cursor: default"
              type="danger"
              size="small"
              >已领取</el-button
            > -->
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      custom-class="link-code-dialog"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
    >
      <div class="title">扫码领用福报</div>
      <div class="qr-code">
        <img :src="imageSrc" alt="" style="width: 180px; height: 180px" />
      </div>
      <div class="tips">打开微信扫一扫</div>
      <el-button style="margin: 10px 82px 0" @click="refreshTake"
        >我已绑定，点击刷新领取</el-button
      >
    </el-dialog>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  data() {
    return {
      integralTaskList: [],
      isLink: false,
      dialogVisible: false,
      imageSrc: "",
      base64Data: "",
      currentTaskId: "",
      loading: false,
      visible: false,
    };
  },
  created() {
    this.getCsgIntegralTask();
  },
  watch: {
    $route() {
      // 监听路由变化
      if (this.$route.path === "/fortuneTask") {
        this.getCsgIntegralTask();
      }
    },
  },
  methods: {
    convertBase64ToImage() {
      const img = new Image();
      img.src = this.base64Data;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        context.drawImage(img, 0, 0);
        const imageURL = canvas.toDataURL("image/png");
        this.imageSrc = imageURL;
      };
    },
    getCsgIntegralTask() {
      this.api("getCsgIntegralTask").then((res) => {
        if (res.result) {
          this.integralTaskList = res.result;
        }
      });
    },
    goCompleteHandle() {
      this.jump("/personalData");
    },
    takeHandle(item) {
      console.log("=======>", item);
      this.currentTaskId = item.taskId;
      if (Number(item.receiveType) === 3) {
        this.loading = true;
        this.getUnlimitedQRCodeByUser(item);
      } else {
        this.takeFun(item.taskId);
      }
    },
    getUnlimitedQRCodeByUser() {
      this.api("getUnlimitedQRCodeByUser", {
        envVersion: this.u_config.envVersion,
      }).then((res) => {
        if (res.result && res.result.base64) {
          this.imageSrc = res.result.base64;
          this.dialogVisible = true;
          this.loading = false;
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    takeFun(taskId) {
      this.api("receiveIntegral", { taskId: taskId }).then((res) => {
        if (res.result) {
          this.dialogVisible = false;
          Message({
            message: res.result,
            type: "success",
            duration: 1500,
          });
          this.getCsgIntegralTask();
          this.$store.dispatch("getPersonalData");
        }
      });
    },
    refreshTake() {
      this.takeFun(this.currentTaskId);
    },
  },
};
</script>
<style scoped lang="scss">
.loading-style {
  position: absolute;
  width: 1000px;
  margin: 0 auto;
  margin-top: 200px;
}

.personal-data-container {
  width: 1002px;
  height: 100%;
  border-radius: 10px;
  margin: 30px auto;
  background: rgb(255, 255, 255);
  border-radius: 10px;
  box-shadow: rgba(121, 121, 121, 0.4) 0px 1px 5px 0px;

  .personal-header {
    height: 30px;
    line-height: 30px;
    padding: 30px 80px 20px;
    display: flex;
    align-items: center;
    img {
      height: 24px;
      margin-right: 10px;
    }
    span {
      font-weight: bold;
      position: relative;
      display: inline-block;
      font-size: 18px;
    }
  }

  .personal-content {
    padding: 20px 80px;

    .fubao-item {
      padding-bottom: 15px;
      margin-bottom: 15px;
      border-bottom: 1px solid #ddd;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .fubao-item-icon {
        float: left;
        width: 70px;
        height: 70px;
        border-radius: 8px;
        background: rgb(226, 226, 226);

        .el-icon-edit-outline {
          display: block;
          font-size: 36px;
          line-height: 70px;
          color: #848484;
          text-align: center;
        }
      }

      .fubao-item-content {
        overflow: hidden;
        .title {
          line-height: 30px;
          margin-bottom: 10px;
        }

        .tips {
          color: #848484;
          font-size: 14px;
        }

        .refresh-button {
          margin: 15px 82px 0;
        }
      }

      .improve-block {
        display: flex;
      }
    }
  }
  .subtitle {
    margin: 0 80px;
    background: #f9eeee;
    padding: 40px 15px;
    border-radius: 5px;
    font-size: 14px;
    text-align: center;
    color: #dc5158;
    p {
      margin: 0;
    }
  }
}

.link-code-dialog {
  .title {
    font-size: 22px;
    text-align: center;
    color: #333;
  }

  .qr-code {
    width: 180px;
    height: 180px;
    margin: 20px auto;
  }

  .tips {
    font-size: 16px;
    text-align: center;
  }
}
.popover-code {
  img {
    width: 100%;
  }
  .text {
    font-size: 13px;
    text-align: center;
    padding: 20px 0;
  }
}
.awm {
  display: flex;
  flex-direction: column;
  align-items: center;
  .pic {
    width: 120px;
    height: 120px;
  }
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
  .text {
    font-size: 12px;
    text-align: center;
    opacity: 0.6;
    padding-top: 5px;
  }
}
</style>
<style lang="scss">
.personal-data-container {
  .personal-header {
    .icon2{
      display: none;  
    }
  }
}
.dark .personal-data-container {
  .personal-header {
    .icon2{
      display: inline-block;  
    }
    .icon1{
      display: none;
    }
  }
  .subtitle {
    background: #111;
  }
  .personal-content .fubao-item {
    border-color: #222;
  }
}
</style>
